<template>
  <div class="slider-file" :class="{'slider-file_open': openSlider}">
    <div class="slider-file__close-button" @click="close()">
      <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M31.6666 10.6833L29.3166 8.33325L19.9999 17.6499L10.6833 8.33325L8.33325 10.6833L17.6499 19.9999L8.33325 29.3166L10.6833 31.6666L19.9999 22.3499L29.3166 31.6666L31.6666 29.3166L22.3499 19.9999L31.6666 10.6833Z" fill="white"/>
      </svg>
    </div>
    <div class="swiper" :class="'swiper'">
      <div class="slider-file__content swiper-wrapper">
        <div v-for="file in files" class="slider-file__slide swiper-slide" :data-type="file.type">
          <template v-if="checkedType(file)">
            <img class="image file" alt="файл" :src="file.src">
          </template>
          <template v-else>
            <video class="video file" controls type='video/mp4' :key="file.uuid">
              <source class="file" :src="file.src">
            </video>
          </template>
        </div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
  </div>
</template>

<script>
import eventBus from "@/js/eventBus";
import Swiper from '@/js/swiper-bundle.js';

export default {
  name: "SliderFile",
  data() {
    return {
      openSlider: false,
      files: [],
      swiperConfig: '',
    }
  },
  methods: {
    checkedType(file) {
      if (file.type.split('/')[0] === 'image') {
        return true;
      }
      return false;
    },
    close() {
      this.openSlider = false;
    },
    initSlider () {
      this.swiperConfig = new Swiper('.swiper', {
        speed: 400,
        spaceBetween: 100,
        rewind: true,
        observer: true,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      this.swiperConfig.on('slideChange', function () {
        const prevIndex = this.previousIndex;
        if (this.slides[prevIndex] === undefined) {
          return
        } else if (this.slides[prevIndex].dataset.type.split('/')[0] === 'video') {
          this.slides[prevIndex].querySelector('.video').pause();
        }
      })
    },
  },
  mounted() {
    eventBus.$on('custom-event', (files, indexFile) => {
      setTimeout(() => {
        this.swiperConfig.slideTo(indexFile, 500, false);
      }, 50)
      this.files = files;
      this.openSlider = true;
    })

    this.initSlider();
  },
  updated() {
    if (!this.openSlider) {
      const videoFiles = this.$el.querySelectorAll('.video');
      if (videoFiles.length >= 1) {
        videoFiles.forEach(item => item.pause())
      }
    };
  }
}

</script>

<style scoped>

</style>